import ReactDOMServer from 'react-dom/server';
import Translate from '../components/translate/conf';
import { toast } from 'react-toastify';

export const calculateWindowSize = (windowWidth) => {
    if (windowWidth >= 1200) {
        return 'lg';
    }
    if (windowWidth >= 992) {
        return 'md';
    }
    if (windowWidth >= 768) {
        return 'sm';
    }
    return 'xs';
};

const isValidIPv4 = (ipAddress) => {
    let pattern = /^(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[0-9]{1,2})(\.(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[0-9]{1,2})){3}$/
    return pattern.exec(ipAddress)
}

export const isValidHost = (ipHost,name) => { 
    if( ipHost == "0.0.0.0" || ipHost == "255.255.255.255" || !isValidIPv4(ipHost) ){
      let err = ReactDOMServer.renderToString(<Translate transVar='error.label' />)+' '
      err += ReactDOMServer.renderToString(name)+' '
      err += ReactDOMServer.renderToString(<Translate transVar='error.InvalidValue' />)
      toast.error(err)
      return false;
    }
    return true;
  }

export const isValidMask = (ipMask,name) => {
    if( !isValidIPv4(ipMask) ){
      let err = ReactDOMServer.renderToString(<Translate transVar='error.label' />)+' '
      err += ReactDOMServer.renderToString(name)+' '
      err += ReactDOMServer.renderToString(<Translate transVar='error.InvalidValue' />)
      toast.error(err)
      return false;
    }
    return true;
  }